<template>
    <o-card :title="$t('medtastic.events')" class="col-lg-8 mx-auto d-block pb-3" :enable-back="true">

        <div class="pt-3">
          <a target="_blank" class="btn btn-dark" :href="'/documents/overview_' + locale + '.pdf'">{{ $t('medtastic.event_pdf_download') }}</a>
        </div>

        <hr>

        <div class="mb-3 pre-formatted">
            {{ $t('medtastic.event_text') }}
        </div>

        <b-form-select v-model="filterLanguage" :options="filterLanguages"  v-on:change="workshops"></b-form-select>

        <template v-if="loaded">
          <template v-if="workshopsList.length === 0">
            <hr>
            {{ $t('medtastic.no_events') }}
          </template>
          <template v-else>
            <div v-for="workshop in workshopsList" class="pb-3">
                <hr>

                <h4>{{ workshop.title }}</h4>

                <div class="row">
                    <div class="col">
                        <table class="table-responsive table-borderless">
                            <tr>
                                <td width="58%">{{ $t('medtastic.region') }}</td>
                                <td>{{ workshop.region }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('core.date') }}</td>
                                <td>{{ workshop.date|formatDate }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('medtastic.time') }}</td>
                                <td>{{ workshop.time|formatTimeString }}</td>
                            </tr>
                            <tr v-if="!filterLanguage">
                                <td>{{ $t('core.language') }}</td>
                                <td>{{ filterLanguages[workshop.language] }}</td>
                            </tr>
                        </table>

                        <router-link :to="{ name: 'medtastic.event_detail', params: {id: workshop.id} }" class="btn btn-dark">
                            {{ $t('medtastic.details') }}
                        </router-link>
                    </div>
                    <div class="col" v-if="workshop.picture">
                        <img :src="'/api/medtastic/workshops/thumbnail/' + workshop.id" :alt="workshop.title" class="img-fluid">
                    </div>
                </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="btn-loading">&nbsp;<br>&nbsp;<br>&nbsp;</div>
        </template>
    </o-card>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    layout: 'user',
    data() {
      return {
        filterLanguage: '',
        filterLanguages: {},
        workshopsList: [],
        loaded: false
      }
    },
    created () {
      this.filterLanguages = Object.assign({ '': this.$i18n.t('medtastic.all_languages') },
        window.config.workshop_locale
      )
    },
    computed: mapGetters({
      locale: 'lang/locale'
    }),
    methods: {
      workshops: function () {
        this.loaded = false
        axios.get('/api/medtastic/workshops/public?per_page=99999&sortBy=date&filter%5Bhide_past_workshops%5D=1&filter%5Blanguage%5D=' + this.filterLanguage)
          .then((response) => {
            this.workshopsList = response.data.data
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
        })
      }
    },
    mounted () {
      this.workshops()
    }
  }
</script>
